// extracted by mini-css-extract-plugin
module.exports = {"bookCardsList":"AuthorDetail_bookCardsList__A27Uh","h2":"AuthorDetail_h2__H4xKl","litresAuthorLink":"AuthorDetail_litresAuthorLink__cr7ht"};